import moment from 'moment';
import * as Yup from 'yup';

import { FormErrorMessage, Input } from '@treams/treams-ui';

import { ISheetEditorEvents } from '../types/sheet';

const BulkDateField = ({
	value,
	events,
	validationSchema,
}: {
	value: string | undefined;
	events: ISheetEditorEvents;
	validationSchema?: Yup.StringSchema;
}) => {
	const invalid = validationSchema ? !validationSchema.isValidSync(value) : false;
	const date = value?.length ? moment(value).toDate() : undefined;

	return (
		<>
			<Input.DatePicker
				autoFocus
				value={date}
				onChange={(date) => {
					if (date) {
						events.onChange(moment(date).add(12, 'hours').toISOString());
					} else {
						events.onChange(undefined);
					}
				}}
			/>
			{invalid && <FormErrorMessage error={new Error('Field invalid.')} />}
		</>
	);
};

export default BulkDateField;
